var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 17V0H9L9.4 2H15V12H8L7.6 10H2V17H0ZM9.65 10H13V4H7.75L7.35 2H2V8H9.25L9.65 10Z","fill":"#1C1B1F"}));
}

Flag.defaultProps = {"width":"15","height":"17","viewBox":"0 0 15 17","fill":"none"};

module.exports = Flag;

Flag.default = Flag;
